import { APITransport } from '@client/transports/api';

export const PitchService = {
  getAll(query = {}) {
    return APITransport.get({
      path: '/rest/user/report/pitchdata2',
      query
    });
  }
};
